/**
 * Testimonials Component
 *
 * Customer testimonials carousel/slider.
 * Features:
 * - Swiper.js carousel for smooth sliding
 * - Navigation arrows for manual control
 * - Multiple testimonial cards with quotes
 * - Displays customer name and profession
 * - Responsive design
 */

// Swiper React components for carousel functionality
import { Swiper, SwiperSlide } from "swiper/react";
// Swiper CSS styles (required for carousel to work properly)
import "swiper/css";
import "swiper/css/navigation";
// Swiper modules - Navigation enables prev/next arrow buttons
import { Navigation } from "swiper/modules";
// React Icons - Quote icon for testimonials
import { IoMdQuote } from "react-icons/io";

// Testimonials data - Customer reviews
const testimonials = [
  {
    message:
      "The most consistent roast in the city. Their Ethiopia Yirgacheffe pour-over changed how I think about coffee—it’s pure liquid gold.",
    name: "Alice Johnson",
    profession: "Creative Director",
  },
  {
    message:
      "A workspace that finally understands silence and quality. The baristas know my order and the extraction is always technically perfect.",
    name: "Michael Lee",
    profession: "Lead Architect",
  },
  {
    message:
      "The botanical latte selection is unlike anything else in the industry. Sophisticated, subtle, and incredibly beautifully presented.",
    name: "Samantha Green",
    profession: "Gastronomy Critic",
  },
];

const Testimonials = () => {
  return (
    <section className="h-[60vh] xl:h-[70vh]">
      <div className="container mx-auto h-full flex items-center">
        {/* Swiper Carousel Component */}
        {/* navigation={true}: Shows prev/next arrow buttons */}
        {/* modules={[Navigation]}: Enables navigation functionality */}
        <Swiper className="h-100" modules={[Navigation]} navigation={true}>
          {testimonials.map((person, index) => (
            // Each testimonial is a slide
            <SwiperSlide key={index} className="w-full h-full">
              <div className="flex justify-center h-full xl:pt-14">
                {/* Testimonial Card Content */}
                <div className="max-w-[60%] text-black">
                  {/* Quote Icon - Large, centered */}
                  <IoMdQuote className="text-6xl text-black mb-12 mx-auto" />

                  {/* Testimonial Message */}
                  <p className="text-xl md:text-2xl font-secondary text-center mb-8">
                    {person.message}
                  </p>

                  {/* Customer Information */}
                  <div className="text-center">
                    {/* Customer Name - Bold */}
                    <p className="text-xl font-bold mb-1">{person.name}</p>
                    {/* Customer Profession - Secondary color */}
                    <p className="text-secondary">{person.profession}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
